export enum KeycloakRoleEnum {
  ADMIN = 'admin',
  PARTNER = 'partner',
  CUSTOMER = 'customer',
}
